// extracted by mini-css-extract-plugin
export var active = "_1v-d";
export var blink = "_1v-e";
export var container = "_1v-5";
export var controls = "_1v-0";
export var controlsRight = "_1v-1";
export var fakeCursor = "_1v-c";
export var hidden = "_1v-b";
export var quillContainerSmall = "_1v-7";
export var quillEditor = "_1v-6";
export var quillEditorSmall = "_1v-8";
export var quillFormatButtons = "_1v-a";
export var quillToolbar = "_1v-9";
export var removePadding = "_1v-2";
export var state = "_1v-3";
export var stateTitle = "_1v-4";